import React, { FC, useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { ChartData, ChartOptions } from 'chart.js';

// Styles
import './line-chart.scss';

// Models
import { IChartLines } from '../../../interfaces/charts.interfaces';
import { CLineDatasetDefaultOptions, CLineChartOptions, CLineChartPlugins } from '../../../constantes/charts.constants';
import { ICurrency } from '../../../interfaces/company.interfaces';

export type TLineChartData = {};

type TLineChartProps = {
  labels: string[];
  lines: IChartLines[];
  currency: ICurrency;
  emptyData?: boolean;
};

export const LineChart: FC<TLineChartProps> = (
  { labels, lines, currency, emptyData = false }: TLineChartProps
) => {

  const getLineBorderColor = (idx: number): string => {
    if (idx === 0) return '#21917F';
    if (idx === 1) return '#C41A1E';
    return Math.floor(Math.random() * 16777215).toString(16);
  }

  const getMaxValue = (): number => {
    return Math.max(
      ...lines.reduce((acc, line) => (
        [...acc, ...line.data.filter(num => !Number.isNaN(num))]), [] as Array<number>
      )
    ) / 0.9;
  }

  const memoOptions: ChartOptions<'line'> = useMemo(() => {
    return ({
      ...CLineChartOptions,
      plugins: {
        ...CLineChartOptions.plugins,
        tooltip: {
          ...CLineChartOptions.plugins?.tooltip,
          callbacks: {
            title: (tooltipItems: any[]): string | string[] | void => {
              return tooltipItems.map(tooltip => `${ currency.symbol }${ tooltip.raw }`)
            },
            label: (): string | string[] | void => '',
          },
        },
      },
      scales: {
        ...CLineChartOptions.scales,
        y: {
          ...CLineChartOptions.scales!.y,
          suggestedMin: 0,
          suggestedMax: getMaxValue() === 0 ? 100 : getMaxValue(),
          ticks: {
            callback: (label) => {
              let numValue: number | string = Number(label);
              if (numValue > 1000) {
                numValue = (numValue / 1000) + 'K'
              }
              return `${ currency.symbol }${ numValue }`;
            }
          },
        },
      }
    })
  }, [lines, labels]);

  const data: ChartData<"line", TLineChartData, string> = useMemo(() => {
    return ({
      labels,
      datasets: lines.map(({ label, data }, idx) => ({
        label,
        data,
        borderColor: getLineBorderColor(idx),
        ...CLineDatasetDefaultOptions
      })),
    });
  }, [lines, labels]);

  return (
    <div className="line-chart">
      { !emptyData && <div className="line-chart--view">
        <Line options={ memoOptions } plugins={ [CLineChartPlugins] }
              data={ data }
        />
      </div> }

      { emptyData && <div className="line-chart--empty">
        No data to display
      </div> }

      {/*<div className="line-chart--axes">*/}
      {/*  { lines.map(({ label }, idx) => <div key={ idx } className="axes-item">*/}
      {/*    <span className="axes-item--point"*/}
      {/*          style={ { backgroundColor: getLineBorderColor(idx) } }/> { label }*/}
      {/*  </div>) }*/}
      {/*</div>*/}
    </div>
  );
}
